module.exports = __webpack_public_path__ + "static/media/STEM_orders2@3x.b1951bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/STEM_orders2@3x.png
// module id = 762
// module chunks = 0